/**
 * Module-level store for navigating Explore Files to a specific folder.
 * Projects page sets this before navigating to /files.
 * ExploreFilesPage reads and clears it during initialisation.
 */

let _pendingFolderRequest = null; // { id: string, name: string }

export function setPendingFolderRequest(id, name) {
  _pendingFolderRequest = { id, name };
}

export function takePendingFolderRequest() {
  const req = _pendingFolderRequest;
  _pendingFolderRequest = null;
  return req;
}
